import { useState } from "react";
import { Link } from "@tanstack/react-router";
import logo from "@/assets/kk-logo.webp";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { PROCEDURES } from "@/content/inner-pages";

const NAV = [
  { label: "Início", href: "/" },
  { label: "Especialidades", href: "/especialidades", route: true, submenu: true },
  { label: "O médico", href: "/dr-kelson-kawamura", route: true },
  { label: "Primeira consulta", href: "/primeira-consulta-cirurgia-plastica", route: true },
  { label: "Localização", href: "/consultorio-cirurgia-plastica-foz-do-iguacu", route: true },
  { label: "Blog", href: "/blog", route: true },
] as { label: string; href: string; route?: boolean; submenu?: boolean }[];

const WHATSAPP =
  "https://wa.me/5545999175813?text=" +
  encodeURIComponent(
    "Olá! Gostaria de agendar uma consulta com o Dr. Kelson Kawamura."
  );

export function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="kk-header">
      <div className="kk-header__inner">
        <Link to="/" aria-label="Dr. Kelson Kawamura — Início">
          <img src={logo} alt="Kawamura Cirurgia Plástica" className="kk-header__logo" width={240} height={166} fetchPriority="high" decoding="async" />
        </Link>

        <nav className="kk-nav" aria-label="Navegação principal">
          {NAV.map((item) =>
            item.submenu ? (
              <div className="kk-nav__item" key={item.href}>
                <Link
                  to={item.href}
                  className="kk-nav__link-caret"
                  activeProps={{ style: { color: "var(--kk-champagne)" } }}
                >
                  {item.label}
                  <svg
                    className="kk-nav__caret"
                    viewBox="0 0 24 24"
                    width="14"
                    height="14"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path d="m6 9 6 6 6-6" />
                  </svg>
                </Link>
                <div className="kk-dropdown">
                  <ul>
                    {PROCEDURES.map((p) => (
                      <li key={p.slug}>
                        <Link to={p.path}>{p.name}</Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ) : item.route ? (
              <Link key={item.href} to={item.href} activeProps={{ style: { color: "var(--kk-champagne)" } }}>
                {item.label}
              </Link>
            ) : (
              <a key={item.href} href={item.href}>
                {item.label}
              </a>
            ),
          )}
        </nav>

        <a href={WHATSAPP} target="_blank" rel="noopener noreferrer" className="kk-button-primary kk-header__cta">
          Agendar consulta <WhatsAppIcon />
        </a>

        <button
          className="kk-burger"
          aria-label="Abrir menu"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? "✕" : "☰"}
        </button>
      </div>

      <div className={`kk-mobile-menu${open ? " is-open" : ""}`} inert={!open || undefined}>
        <div className="kk-mobile-menu__inner">
          {NAV.map((item) => (
            <div key={item.href}>
              {item.route ? (
                <Link to={item.href} onClick={() => setOpen(false)}>
                  {item.label}
                </Link>
              ) : (
                <a href={item.href} onClick={() => setOpen(false)}>
                  {item.label}
                </a>
              )}
              {item.submenu ? (
                <div className="kk-mobile-menu__sub">
                  {PROCEDURES.map((p) => (
                    <Link key={p.slug} to={p.path} onClick={() => setOpen(false)}>
                      {p.name}
                    </Link>
                  ))}
                </div>
              ) : null}
            </div>
          ))}
          <a
            href={WHATSAPP}
            target="_blank"
            rel="noopener noreferrer"
            className="kk-button-primary"
            style={{ marginTop: 16 }}
          >
            Agendar consulta <WhatsAppIcon />
          </a>
        </div>
      </div>
    </header>
  );
}
